"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Web3Helper = void 0;
const web3_eth_abi_1 = require("web3-eth-abi");
const Utils = require("web3-utils");
const functions = require("./functions.json");
const PREFIX_LENGTH = 2;
const FUNCTION_NAME_LENGTH = 8;
class Web3HelperImpl {
    paramsToString(method, params) {
        let i = 0;
        return method.inputs ? method.inputs.reduce((res, input) => {
            return `${res}    ${input.name} (${input.type}): ${params[i++]}\n`;
        }, "") : "";
    }
    encodeMethod(method, params) {
        if (typeof method === "string") {
            method = this.getMethod(method);
        }
        return web3_eth_abi_1.encodeFunctionCall(method, this.encodeNumbericParameters(params));
    }
    decodeMethod(data) {
        const signature = `0x${data.substring(PREFIX_LENGTH, PREFIX_LENGTH + FUNCTION_NAME_LENGTH)}`;
        const abi = functions[signature];
        if (!abi) {
            throw new Error(`Could not find function for signature: ${signature}`);
        }
        abi.type = "function";
        const inputs = abi.inputs;
        let decodedParams = [];
        if (inputs.length > 0) {
            const encodedParams = `0x${data.substring(PREFIX_LENGTH + FUNCTION_NAME_LENGTH)}`;
            decodedParams = web3_eth_abi_1.decodeParameters(inputs, encodedParams);
        }
        return {
            method: abi,
            params: decodedParams,
        };
    }
    isAddress(address) {
        return Utils.isAddress(address);
    }
    getMethod(methodName) {
        const sha3 = Utils.sha3(methodName);
        if (!sha3) {
            throw new Error(`Invalid method name '${methodName}'`);
        }
        const signature = sha3.substring(0, PREFIX_LENGTH + FUNCTION_NAME_LENGTH);
        const method = functions[signature];
        if (!method) {
            throw new Error(`Could not find known method '${methodName}' from known methods list`);
        }
        method.type = "function";
        return method;
    }
    getMethodNames() {
        return Object.entries(functions).map((method) => {
            return method[1].name || "";
        });
    }
    encodeParameters(inputAbi, params) {
        return web3_eth_abi_1.encodeParameters(inputAbi, this.encodeNumbericParameters(params)).replace("0x", "");
    }
    encodeNumbericParameters(params) {
        return params.map((p) => Number.isFinite(p) ? Utils.numberToHex(p) : p);
    }
}
exports.Web3Helper = new Web3HelperImpl();
//# sourceMappingURL=index.js.map